import tippy from 'tippy.js';
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tippy"
export default class extends Controller {
  static values = {
    placement: String
  }

  connect() {
    this.instance = tippy(this.element, {
      content: this.element.title
    })
  }

  disconnect() {
    this.instance.destroy()
  }
}
